import React, { useEffect } from "react";
import SelectStyles from "./SelectStyles";
import "../styles/input.scss";
import Select from "react-select";

export default function AppSelect({
  label,
  id,
  name,
  placeholder,
  onChange,
  value,
  rowMode,
  readOnly = false,
  options = [],
  noLabel,
  inputStyle,
  focused = false,
  autoFocus,
  leftIcon,
  required,
  style,
}) {
  const ref = React.createRef();
  function focus() {
    ref.current.focus();
  }
  useEffect(() => {
    if (focused !== false) {
      focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focused]);
  return (
    <div
      className="form-group"
      style={
        rowMode
          ? {
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              position: "relative",
            }
          : style
      }
    >
      {!noLabel && (
        <label
          htmlFor={id}
          style={
            rowMode && {
              marginRight: 10,
              fontWeight: "600",
              flexGrow: 1,
              marginTop: 10,
            }
          }
        >
          {label}
        </label>
      )}
      <div
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
        }}
      >
        {leftIcon && (
          <div style={{ position: "absolute", left: 10, zIndex: 10 }}>
            {leftIcon}
          </div>
        )}

        <Select
          id={id}
          ref={ref}
          name={name || id}
          defaultValue={placeholder}
          className={`form-control input-select`}
          placeholder={placeholder}
          autoFocus={autoFocus}
          required={required}
          styles={{
            ...SelectStyles,
            control: (base, state) => ({
              ...base,
              borderBottom: state.isFocused
                ? `2px solid var(--primary)!important`
                : `1px solid var(--primary50)!important`,
              boxShadow: 0,
              borderRadius: 3,
              borderColor: "transparent !important",
              width: "100%",
              textIndent: leftIcon ? 30 : 0,
              // marginTop: -4,
            }),
            input: (styles) => ({
              ...styles,
              width: 500,
              maxWidth: 135,
              ...inputStyle,
              backgroundColor: "white !important",
            }),
          }}
          options={options.map((i) => ({
            label: i,
            value: i,
          }))}
          value={{ value, label: value || placeholder }}
          onChange={(event) => {
            !readOnly &&
              onChange &&
              onChange({
                currentTarget: {
                  name: name || id,
                  value: event.value,
                },
              });
          }}
          onKeyUp={onChange}
        />
      </div>
    </div>
  );
}
